import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdSense from 'react-adsense';
import { useNavigate, Link, useParams } from "react-router-dom";
import { alert_error, alert_success } from './../../AppContext';
import { Cookies } from './../../index.js';
import { ClipLoader } from "react-spinners";
import Language_i18 from '../../js/useNationalLanguage.jsx';
const InviteFriends = () => {
  const { i18n, lang } = Language_i18();
  const [nutxuly, setnutxuly] = useState(0);
  const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
  const [money, setmoney] = useState('');
  const [data_coin, set_data_coin] = useState('');
  const labels = {
    vi: {
      copied: "Đã sao chép",
      noApiKey: "Không có API key.",
      continueOrder: "đặt tiếp luôn nào",
      balanceTitle: "Số hust coin bán Coins :",
      withdrawIntro: "Để nhận tiền bạn cần rút số dư hust coin bán Coins.",
      limitsLine:
        "💸 bank min {bank_min} max {bank_max}, crypto min {crypto_min} max {crypto_max}, binance min {binance_min} max {binance_max}, momo min {momo_min} max {momo_max}, partner min {partner_min} max {partner_max}.",
      oncePerDay: "Rút tối đa 1 lần mỗi ngày",
      autoAdjust:
        "Nếu dư nhiều hơn thì tự động trừ nha 🥰 Bạn không lo bị ảnh hưởng đâu nè! 😘",
      contactAdmin: "Mỗi lần rút tiền ib admin để được duyệt",
    },
    en: {
      copied: "Copied",
      noApiKey: "No API key found.",
      continueOrder: "place another order now",
      balanceTitle: "Coins selling balance:",
      withdrawIntro: "To receive money, you need to withdraw your Coins selling balance.",
      limitsLine:
        "💸 bank min {bank_min} max {bank_max}, crypto min {crypto_min} max {crypto_max}, binance min {binance_min} max {binance_max}, momo min {momo_min} max {momo_max}, partner min {partner_min} max {partner_max}.",
      oncePerDay: "Maximum 1 withdrawal per day",
      autoAdjust:
        "If the balance is higher, the extra amount will be adjusted automatically 🥰 You do not need to worry about any impact! 😘",
      contactAdmin: "Message the admin for approval each time you withdraw money",
    }
  };
  const currentLabels = labels?.[lang] || labels.vi;
  const datahome = {
    links: [
      {
        to: "/reactapp/nhatkyorders",
        text: {
          vi: "Nhất ký rút tiền",
          en: "History withdraw money"
        }
      },
      {
        to: "/shop/e-commerce/seller/buycard?showadview=true",
        text: {
          vi: "Rút qua thẻ cào",
          en: "Withdraw on scratch card"
        }
      },
      {
        to: "/shop/e-commerce/seller/pay_bank?showadview=true",
        text: {
          vi: "Rút qua ngân hàng",
          en: "Withdraw on bank"
        }
      },
      {
        to: "/shop/e-commerce/seller/pay_crypto?showadview=true",
        text: {
          vi: "Rút qua crypto",
          en: "Withdraw on crypto"
        }
      },
      {
        to: "/shop/e-commerce/seller/pay_binance?showadview=true",
        text: {
          vi: "Rút qua binance",
          en: "Withdraw on Binance"
        }
      },
      // {
      //   to: "/shop/e-commerce/seller/pay_momo?showadview=true",
      //   text: {
      //     vi: "Rút qua momo (bảo trì)",
      //     en: "Withdraw on Momo (maintenance)"
      //   }
      // },
      {
        to: "/shop/e-commerce/seller/edit_bank?showadview=true",
        text: {
          vi: "Cấu hình ngân hàng",
          en: "Configure bank account"
        }
      },
      {
        to: "/shop/transfer_coins?showadview=true",
        text: {
          vi: "Chuyển coin bán Coins",
          en: "Transfer coins to sell"
        }
      }
    ]
  };

  const laythongtin = (apikey, service) => {
    axios
      .post('https://hust.media/api/wallet/e_commerce/coin_digital_get.php', {
        apikey: apikey,
        service: service
      })
      .then(response =>
        testFunction4(response, service)
      )
      .catch(error => console.log(123 + error));
  };
  const testFunction4 = (response, service) => {
    console.log(response);
    const info = response.data;
    if (info.money) {
      setmoney(info.money);
      set_data_coin(info);
    }
  };
  const laydulieu = () => {
    const apiKey = Cookies.get('apikey');
    if (apiKey !== null) {
      // Có API key, thực hiện các hành động cần thiết
      laythongtin(apiKey, 'getmoney');
    } else {
      // Không có API key, thực hiện các hành động khác (ví dụ: yêu cầu người dùng nhập API key)
      console.log(currentLabels.noApiKey);
    }
  };
  useEffect(() => {
    // Kiểm tra xem có giá trị "apikey" trong AsyncStorage không
    laydulieu();
  }, []);
  function saochep(value) {
    alert_success(currentLabels.copied);
    window.saochepnative(value);
  };

  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutorder(currentLabels.continueOrder)
    setnutxuly(0);
    if (status == 0) {
      alert_error(info.message);
    }
    else if (status == 1) {
      alert_success(info.message);
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  return (
    <div className="mt-2 mx-2">
      {!money ? (<>
        <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
          <ClipLoader size={90} color="#8a2be2" />
        </div>
      </>) : (<>
        <div className="max-w-xl mt-2 mx-2 mx-auto">
          <div className="bg-white p-2 rounded-md shadow-md ">
            <div className="bg-gray-100 rounded-md shadow-md border-1 border-purple-300">
              <div className="text-base mt-2 text-center font-semibold">{currentLabels.balanceTitle}</div>
              <div className="mb-2 text-center text-lg text-purple-700">{money} coins</div>
            </div>
          </div>
          <form className="mt-2 mb-1 add-form">
            <div className="form-control">
              <div className="mx-2">
                <label className="mt-1 text-base">{currentLabels.withdrawIntro}
                </label>
                <div className='mt-0 text-sm'>{currentLabels.limitsLine
                  .replace("{bank_min}", data_coin.bank_min)
                  .replace("{bank_max}", data_coin.bank_max)
                  .replace("{crypto_min}", data_coin.crypto_min)
                  .replace("{crypto_max}", data_coin.crypto_max)
                  .replace("{binance_min}", data_coin.binance_min)
                  .replace("{binance_max}", data_coin.binance_max)
                  .replace("{momo_min}", data_coin.momo_min)
                  .replace("{momo_max}", data_coin.momo_max)
                  .replace("{partner_min}", data_coin.partner_min)
                  .replace("{partner_max}", data_coin.partner_max)}
                </div>
                <div className='mt-0 text-sm'>
                  {currentLabels.oncePerDay} <br />
                  {currentLabels.autoAdjust}
                  <br />
                  <span className="inline-block rounded-md bg-pink-100 px-2 py-0.5 text-pink-700">
                    {currentLabels.contactAdmin}
                  </span>
                </div>
                <div className="max-w-5xl mx-auto">
                  <div className="bg-white p-3 rounded-md shadow-md md:col-span-2">
                    <div className="fixrow row text-center">
                      {datahome.links.map((link, index) => (
                        <Link
                          style={{ textDecoration: 'none' }}
                          to={link.to}
                          className="flex break-inside bg-white text-black border-2 border-black rounded-3xl px-6 py-3 w-auto dark:bg-slate-800 dark:text-white"
                          key={index}
                        >
                          <div className="m-auto">
                            <div className="flex items-center justify-start flex-1 space-x-4">
                              <span className="font-medium px-2 text-lg">
                                {link.text?.[lang] ?? link.text.vi}
                              </span>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="cards">
            <AdSense.Google
              client="ca-pub-4574266110812955"
              slot="3259681051"
              style={{ display: 'block' }}
              format="auto"
              responsive="true"
            /></div>
        </div>
      </>)}
    </div>
  );
};

export default InviteFriends;
